// extracted by mini-css-extract-plugin
export default {"share-list__table-body-height":"share-list__table-body-height_B8Me5xfX"};